import React, { useReducer } from "react";
import { useHistory } from "react-router-dom";

export default (reducer, actions, defaultValue) => {
  const Context = React.createContext();

  const walletOnly = 0;

  const Provider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, defaultValue);
    let history = useHistory();

    const boundActions = {};
    for (let key in actions) {
      boundActions[key] = actions[key](dispatch, history);
    }

    return (
      <Context.Provider value={{ state, ...boundActions }}>
        {children}
      </Context.Provider>
    );
  };

  return { Context, Provider, walletOnly };
};
